import { CSSProperties } from 'react';
import { theme } from '../../theme';

const font = theme.typography.fontFamily;

export const webPaymentStyles = {
  page: {
    backgroundColor: '#F5F5F5',
    fontFamily: font,
    color: theme.colors.label,
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  } as CSSProperties,

  methodsCard: {
    backgroundColor: theme.colors.white,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.large,
    padding: 16,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
  } as CSSProperties,

  desktopMain: {
    width: '100%',
  } as CSSProperties,

  stepTitle: {
    margin: 0,
    fontSize: theme.typography.fontSize.xl,
    lineHeight: theme.typography.lineHeight.xl,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  stepTitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 16,
  } as CSSProperties,

  stepDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.colors.button.primary,
    flexShrink: 0,
  } as CSSProperties,

  listHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  } as CSSProperties,

  listHeaderMobile: {
    flexWrap: 'wrap',
  } as CSSProperties,

  chooseLabel: {
    margin: 0,
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.lg,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  addCardButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing.extraSmall,
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    height: '37px',
    paddingLeft: `${theme.spacing.medium}px`,
    paddingRight: `${theme.spacing.medium}px`,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  } as CSSProperties,

  splitAddButton: {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 6,
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    height: 36,
    padding: '0 12px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  } as CSSProperties,

  dashedAdd: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    border: `1px dashed ${theme.colors.button.primary}`,
    borderRadius: theme.radius.md,
    color: theme.colors.button.primary,
    cursor: 'pointer',
    display: 'flex',
    fontFamily: font,
    fontSize: theme.typography.fontSize.base,
    gap: theme.spacing.extraSmall,
    justifyContent: 'flex-start',
    lineHeight: theme.typography.lineHeight.lg,
    minHeight: 56,
    padding: `${theme.spacing.medium}px`,
    width: '100%',
  } as CSSProperties,

  brandIcon: {
    width: 32,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  } as CSSProperties,

  addCardIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
  } as CSSProperties,

  addCardBlueIcon: {
    height: 21,
    width: 21,
  } as CSSProperties,

  plusIcon: {
    height: 24,
    width: 20,
  } as CSSProperties,

  trashButton: {
    border: 'none',
    background: 'transparent',
    color: theme.colors.subtitle,
    cursor: 'pointer',
    padding: 8,
    flexShrink: 0,
  } as CSSProperties,

  mpPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: 27,
  } as CSSProperties,

  mpLogo: {
    display: 'block',
    width: 241,
    height: 40,
    margin: '4px auto 0',
    objectFit: 'contain',
  } as CSSProperties,

  mpFeatured: {
    position: 'relative',
    border: '1px solid #E5E5E5',
    borderRadius: 4,
    padding: '17px 22px 17px 62px',
  } as CSSProperties,

  mpFeaturedIcon: {
    position: 'absolute',
    left: 22,
    top: '50%',
    width: 24,
    height: 24,
    transform: 'translateY(-50%)',
  } as CSSProperties,

  mpList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 27,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  } as CSSProperties,

  mpItem: {
    position: 'relative',
    margin: 0,
    paddingLeft: 40,
  } as CSSProperties,

  mpItemIcon: {
    position: 'absolute',
    left: 0,
    top: '50%',
    width: 24,
    height: 24,
    transform: 'translateY(-50%)',
  } as CSSProperties,

  mpParagraph: {
    margin: 0,
    color: '#575757',
    fontSize: 14,
    lineHeight: '136%',
    textAlign: 'left',
  } as CSSProperties,

  mobileMain: {
    padding: '8px 0 0',
    backgroundColor: theme.colors.white,
  } as CSSProperties,

  mobileMethodsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '8px 16px 0',
    marginBottom: theme.spacing.medium,
  } as CSSProperties,

  mobileMethodsTitle: {
    margin: `${theme.spacing.extraLarge}px 0`,
    padding: `0 ${theme.spacing.medium}px`,
    fontFamily: font,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.label,
  } as CSSProperties,

  mobileMethodsSubtitle: {
    margin: 0,
    fontFamily: font,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.lg,
    color: theme.colors.subtitle,
  } as CSSProperties,

  mobileAdd: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: 'none',
    background: 'none',
    padding: '4px 0',
    cursor: 'pointer',
    color: theme.colors.button.primary,
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    whiteSpace: 'nowrap',
  } as CSSProperties,

  mobileBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: '8px 16px 0',
  } as CSSProperties,

  splitIntro: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    padding: '8px 16px 0',
  } as CSSProperties,

  splitIntroToggle: {
    marginBottom: -8,
  } as CSSProperties,

  splitFirstCard: {
    marginTop: 20,
  } as CSSProperties,

  splitDivider: {
    padding: '16px 16px 0',
  } as CSSProperties,

  sheetStage: {
    position: 'relative',
    height: '100%',
    overflow: 'hidden',
  } as CSSProperties,

  sheetBackdrop: {
    position: 'absolute',
    inset: 0,
    zIndex: 1,
    backgroundColor: 'rgba(17, 24, 39, 0.45)',
  } as CSSProperties,

  sheet: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2,
    width: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    backgroundColor: theme.colors.white,
    padding: '20px 16px 24px',
    boxSizing: 'border-box',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  } as CSSProperties,

  sectionTitle: {
    margin: '16px 0 8px',
    fontSize: theme.typography.fontSize.lg,
    lineHeight: theme.typography.lineHeight.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  } as CSSProperties,

  skeletonRow: {
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    border: `1px solid ${theme.colors.palette.grey300}`,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.white,
  } as CSSProperties,

  skeletonCircle: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: theme.colors.palette.grey200,
    flexShrink: 0,
  } as CSSProperties,

  skeletonBrand: {
    width: 40,
    height: 28,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.palette.grey200,
    flexShrink: 0,
  } as CSSProperties,

  skeletonTextCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    flex: 1,
    minWidth: 0,
  } as CSSProperties,

  skeletonLinePrimary: {
    display: 'block',
    height: 14,
    width: '62%',
    maxWidth: 220,
    borderRadius: 4,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  skeletonLineSecondary: {
    display: 'block',
    height: 12,
    width: '42%',
    maxWidth: 160,
    borderRadius: 4,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  skeletonMobileCarouselRoot: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 0,
  } as CSSProperties,

  /** App RN y checkout web mobile: tarjeta ancha + franja de la siguiente (carrusel). */
  skeletonMobileCarouselContainer: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
    marginTop: theme.spacing.medium,
  } as CSSProperties,

  skeletonMobileCarouselTrack: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing.small,
    overflow: 'hidden',
    paddingBottom: theme.spacing.tiny,
    boxSizing: 'border-box',
    width: '100%',
  } as CSSProperties,

  skeletonMobileCarouselTrackWeb: {
    paddingLeft: theme.spacing.mediumLarge,
    paddingRight: theme.spacing.mediumLarge,
  } as CSSProperties,

  /** El wrapper de la app ya trae `pl-4`; el carrusel real no duplica padding izquierdo. */
  skeletonMobileCarouselTrackApp: {
    paddingRight: theme.spacing.mediumLarge,
  } as CSSProperties,

  skeletonMobileCarouselCardBase: {
    flex: '1 1 0',
    minWidth: 0,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.palette.grey200,
    border: `1px solid ${theme.colors.palette.grey300}`,
    boxSizing: 'border-box',
  } as CSSProperties,

  /** Misma proporción que `PaymentMethodCard` enfocada (2:1): el skeleton no mueve el layout al cargar la tarjeta real. */
  skeletonMobileCarouselCardPreselected: {
    aspectRatio: theme.sizes.paymentCard.aspectRatio,
  } as CSSProperties,

  /** Misma proporción que `PaymentMethodCard` no enfocada (más baja). */
  skeletonMobileCarouselCardNeutral: {
    aspectRatio: theme.sizes.paymentCard.aspectRatioUnfocused,
  } as CSSProperties,

  skeletonMobileCarouselTrackPreselected: {
    alignItems: 'center',
  } as CSSProperties,

  skeletonMobileCarouselPeek: {
    flex: '0 0 32px',
    minHeight: 144,
    alignSelf: 'center',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.palette.grey200,
    border: `1px solid ${theme.colors.palette.grey300}`,
    boxSizing: 'border-box',
    opacity: 0.55,
  } as CSSProperties,

  /** CVV + 2 tarjetas + cuotas (mobile/app con primera tarjeta preseleccionada al cargar). */
  skeletonMobileSelectedFlow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
    padding: `${theme.spacing.medium}px ${theme.spacing.mediumLarge}px 0`,
    marginTop: theme.spacing.medium,
  } as CSSProperties,

  skeletonMobileLine: {
    display: 'block',
    height: 14,
    borderRadius: 4,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  skeletonMobileCvvField: {
    height: 48,
    width: '100%',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.palette.grey200,
    border: `1px solid ${theme.colors.palette.grey300}`,
    boxSizing: 'border-box',
  } as CSSProperties,

  skeletonMobileToggle: {
    height: 36,
    width: 200,
    maxWidth: '100%',
    borderRadius: 4,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  skeletonMobileInstallmentRow: {
    height: 52,
    width: '100%',
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.palette.grey200,
    border: `1px solid ${theme.colors.palette.grey300}`,
    boxSizing: 'border-box',
  } as CSSProperties,

  /** Misma caja que `addCardButton` para evitar layout shift al cargar tarjetas. */
  skeletonAddCardButton: {
    display: 'inline-block',
    flexShrink: 0,
    width: 132,
    height: 36,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  skeletonMobileAdd: {
    display: 'inline-block',
    flexShrink: 0,
    width: 88,
    height: 26,
    borderRadius: 4,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  row: {
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.colors.palette.grey150,
    borderRadius: theme.radius.md,
    backgroundColor: theme.colors.white,
    overflow: 'hidden',
  } as CSSProperties,

  rowSelected: {
    borderColor: theme.colors.button.primary,
  } as CSSProperties,

  rowButton: {
    width: '100%',
    minHeight: 56,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    border: 'none',
    background: 'transparent',
    textAlign: 'left',
    cursor: 'pointer',
    fontFamily: font,
    color: theme.colors.label,
  } as CSSProperties,

  radio: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.colors.palette.grey400,
    flexShrink: 0,
    boxSizing: 'border-box',
  } as CSSProperties,

  radioOn: {
    borderColor: theme.colors.button.primary,
    boxShadow: `inset 0 0 0 4px ${theme.colors.white}, inset 0 0 0 10px ${theme.colors.button.primary}`,
  } as CSSProperties,

  rowText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  } as CSSProperties,

  rowTitle: {
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.base,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  rowSubtitle: {
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.subtitle,
  } as CSSProperties,

  expanded: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: '0 16px 16px',
  } as CSSProperties,

  splitFields: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: 12,
  } as CSSProperties,

  splitNotice: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    margin: 0,
    padding: '12px 16px',
    borderRadius: 8,
    backgroundColor: theme.colors.palette.lightBlue300,
    boxSizing: 'border-box',
  } as CSSProperties,

  splitNoticeIcon: {
    flexShrink: 0,
    marginTop: 1,
    color: theme.colors.button.primary,
  } as CSSProperties,

  splitNoticeText: {
    margin: 0,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    color: theme.colors.palette.darkGrey200,
    textAlign: 'left',
  } as CSSProperties,

  splitLabel: {
    margin: 0,
    fontSize: theme.typography.fontSize.base,
    lineHeight: theme.typography.lineHeight.base,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.label,
  } as CSSProperties,

  notes: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    margin: 0,
    padding: 0,
    listStyle: 'none',
  } as CSSProperties,

  note: {
    margin: 0,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.base,
    color: theme.colors.subtitle,
  } as CSSProperties,

  sidebar: {
    position: 'sticky',
    top: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  } as CSSProperties,

  giftBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    backgroundColor: theme.colors.white,
    borderRadius: 8,
    padding: '10px 12px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
  } as CSSProperties,

  giftIcon: {
    width: 28,
    height: 26,
    flexShrink: 0,
  } as CSSProperties,

  giftBannerText: {
    margin: 0,
    flex: 1,
    fontSize: 13,
    lineHeight: '16px',
    fontWeight: theme.typography.fontWeight.bold,
    color: '#D30D1F',
  } as CSSProperties,

  giftAction: {
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: font,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: theme.typography.fontWeight.bold,
    padding: '8px 10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flexShrink: 0,
  } as CSSProperties,

  summaryCard: {
    backgroundColor: theme.colors.white,
    borderRadius: 8,
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  } as CSSProperties,

  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    paddingBottom: 8,
    borderBottom: `1px solid ${theme.colors.palette.grey300}`,
  } as CSSProperties,

  summaryTitle: {
    margin: 0,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  viewProducts: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.button.primary,
  } as CSSProperties,

  summaryLine: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    margin: 0,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.subtitle,
  } as CSSProperties,

  summaryDiscount: {
    color: '#D30D1F',
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  savingBanner: {
    margin: 0,
    backgroundColor: '#FFEFEF',
    color: '#D30D1F',
    borderRadius: 4,
    padding: '8px 10px',
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
    textAlign: 'center',
  } as CSSProperties,

  logoRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: 6,
    paddingTop: 4,
  } as CSSProperties,

  logoBox: {
    flex: 1,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.colors.palette.grey300}`,
    borderRadius: 4,
  } as CSSProperties,

  logoImage: {
    width: 24,
    height: 16,
    objectFit: 'contain',
  } as CSSProperties,

  secureRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    margin: 0,
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.subtitle,
  } as CSSProperties,

  secure: {
    margin: 0,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  summaryTotal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 8,
    borderTop: `1px solid ${theme.colors.palette.grey300}`,
  } as CSSProperties,

  summaryAmount: {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  payButton: {
    width: '100%',
    minHeight: 40,
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: font,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
  } as CSSProperties,

  payButtonDisabled: {
    backgroundColor: theme.colors.palette.grey400,
    cursor: 'not-allowed',
  } as CSSProperties,

  promoNote: {
    margin: 0,
    fontSize: theme.typography.fontSize.xs,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.subtitle,
  } as CSSProperties,

  block: {
    marginTop: 16,
  } as CSSProperties,
};
